import type { Auth0ContextInterface } from "@auth0/auth0-react";
import { LocalStorage } from "util/localStorage";

/**
 * The single way to end a session.
 *
 * Auth0's `logout` clears its own token cache and nothing else, so anything we
 * put in localStorage ourselves outlives the agent who put it there. That is not
 * merely untidy: `fuzey:merchant:id` is read on the next boot by
 * `AbstractPrivateRoute`, which hands it to `useMerchantResolution` as the
 * candidate merchant and fetches it in parallel with `/agents/me` — before
 * anything has confirmed the agent can access it. A value naming a merchant they
 * cannot access therefore produces a failed merchant request on every single
 * login, and logging out never cleared it.
 *
 * Every logout in the app goes through here so that can't drift back apart.
 */
export const endSession = (logout: Auth0ContextInterface["logout"]): void => {
  LocalStorage.clearSelectedMerchantId();

  void logout({ logoutParams: { returnTo: window.location.origin } });
};
